import Sidebar from 'components/global/sidebar';
import Navbar from 'components/user/navbar';
import React, { useEffect } from 'react'
import { Swiper , SwiperSlide } from 'swiper/react';
import './styles.css';
import { Pagination , Autoplay , Navigation } from 'swiper';
import bilboards from 'data/bilboards';

const ScreenDetails = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className="w-full pb-20 md:px-0 px-4 pt-24  ">
            <Navbar />
            <div>
                <Sidebar />
            </div>
            <div className="w-full pl md:pr-20 ">
                <div>
                <Swiper
                    slidesPerView={1}
                    spaceBetween={25}
                    pagination={{
                        clickable: true,
                    }}
                    navigation={true}
                    autoplay={{
                        delay: 3000,
                        disableOnInteraction: false,
                    }}
                    speed={1000}
                    loop={true}
                    modules={[Pagination , Autoplay , Navigation]}
                    className="w-full h-full screen-details-slider"
                >
                    {
                        bilboards.map((item,i) => (
                            <SwiperSlide 
                            key={i}
                            >
                                <div>
                                    <img 
                                    src={item} 
                                    alt="Case Study" 
                                    className='w-full mx-auto lg:max-w-[70%] max-h-[350px] lg:h-[400px] h-[300px] object-cover rounded-lg ' 
                                    />
                                </div>
                            </SwiperSlide>
                        ))
                    }
                </Swiper>
                </div>
                <div className='mt-12 lg:pl-36 md:pl-20 flex flex-col gap-10'>
                    <div>
                        <h6 className='font-semibold text-primary'>Venue Type</h6>
                        <div className='mt-4 border border-red-400 py-4 px-12 rounded-md w-fit text-red-500'>
                            On Highway
                        </div>
                    </div>
                    <div>
                        <h6 className='font-semibold text-primary'>Screen Status</h6>
                        <div className='mt-4 border border-green-400 py-4 px-12 rounded-md w-fit text-green-500'>
                            Available
                        </div>
                    </div>
                    <div>
                        <h6 className='font-semibold text-primary'>Restrictions</h6>
                        <div className='flex flex-col gap-2 mt-4'>
                            <div>
                                <span>eCPM:</span> 
                                <span className='text-primary'>20INR</span>
                            </div>
                            <div>
                                <span>Average Impressions:</span> 
                                <span className='text-primary'>Impression not available</span>
                            </div>
                            <div> 
                                <span>Media Duration:</span>
                                <span className='text-primary'>15s</span>
                            </div>
                            <div> 
                                <span>Screen Resolution:</span>
                                <span className='text-primary'>2370x864</span>
                            </div>
                            <div>
                                <span>Media Type:</span>
                                <span className='text-primary'>Video</span>
                            </div>
                            <div>
                                <span>Minimum Plays:</span>
                                <span className='text-primary'>50</span>
                            </div>
                            <div>
                                <span>Ad Medium:</span>
                                <span className='text-primary'>20INR</span></div>
                            </div>
                    </div>
                    <div>
                        <button className="btn-secondary py-2">
                            Add To Cart
                        </button>
                    </div>
                </div>
            </div>

        </div>
    )
}

export default ScreenDetails